import cx from 'classnames'
import * as React from 'react'
import {RefObject} from "react";

import { plus } from '../../../icons'
import type { OptionAccordionsViewModel } from '../../../view-models/OptionAccordionsViewModel'
import CtaButton from '../../CtaButton/CtaButton'
import Icon from '../../Icon/Icon'
import Image from '../../Image/Image'
import Rte from '../../Rte/Rte'
import VideoPlayer from '../../VideoPlayer/VideoPlayer'
import styles from './accordionItem-style.css'
type Props = {
  item: OptionAccordionsViewModel
  open: boolean
  index: number
  onClick: (...args: Array<any>) => any
  id: string
}

function AccordionItem({ item, open, onClick, index, id }: Props) {
  const { title, text, image, video, cta } = item
  const answerElement: RefObject<HTMLButtonElement> = React.createRef()

  const handleOnClick = () => {
    onClick(answerElement, index, id)
  }

  const eventData = cta && cta.link ? cta.link.label : ''

  return (
    <li
      className={cx(styles.accordion, {
        [styles.open]: open,
      })}
      id={id}
    >
      <div className={styles.icon}>
        <Icon iconSrc={plus} />
      </div>
      <button onClick={handleOnClick} className={styles.question} ref={answerElement}>
        {title}
      </button>
      <div
        className={cx(styles.answer, {
          [styles.visible]: open,
        })}
        aria-hidden={!open}
      >
        {text && <Rte source={text} />}
        {image && (
          <div className={styles.imageWrapper}>
            <Image {...image} contain className={styles.image} />
          </div>
        )}
        {video && <VideoPlayer {...video} aspectRatio={9 / 16} />}
        {cta && (
          <CtaButton
            {...cta}
            eventMeta={{
              event: 'cta',
              eventData,
            }}
            noUnderline={!(cta.version === 'link')}
          />
        )}
      </div>
    </li>
  )
}

AccordionItem.displayName = 'AccordionItem'
AccordionItem.defaultProps = {}
export default AccordionItem